export default "__VITE_ASSET__Bfsiahk$__"